import { Button } from 'components/common'
import Modal from 'components/modal'

type Props = {
  isOpen: boolean
  closeModal: () => void
  handleConfirm: () => void
  aggregatorName: string
}

const ConfirmGenerateOrderTokenModal = ({
  closeModal,
  isOpen,
  handleConfirm,
  aggregatorName,
}: Props) => {
  return (
    <Modal
      width={550}
      title={`Are you sure ?`}
      titleClassname="text-xl font-semibold max-w-xl"
      isOpen={isOpen}
      closeModal={closeModal}
      customStyle={{
        padding: '25px 40px',
      }}
    >
      <>
        <p className=" pb-3 text-sm">
          <span>
            Generating store token for{' '}
            <span className="font-bold">
              {aggregatorName} Aggregator. &nbsp;
            </span>
          </span>
          If you confirm, a new token will be sent to your{' '}
          <span className="font-bold">registered email&nbsp;</span>
          address, and your old token will be{' '}
          <span className="font-bold text-red-600">invalidated</span>.
        </p>
        <div className="flex justify-start">
          <Button
            type="button"
            onClick={closeModal}
            buttonText="Cancel"
            className="mr-3"
            variant="outline"
            size="small"
          />
          <Button
            type="button"
            size="small"
            onClick={handleConfirm}
            buttonText="Confirm"
          />
        </div>
      </>
    </Modal>
  )
}

export default ConfirmGenerateOrderTokenModal
